import classNames from 'classnames';
import { FC, memo } from 'react';

import { Skeleton } from '@gem/ui-kit';

import styles from './AvatarPlaceholder.styles.m.css';

export enum AvatarPlaceholderType {
  Round_05 = 'round-05',
  Round_0 = 'round-0',
  Round_10 = 'round-10',
  Square_0 = 'square-0',
  Square_8 = 'square-8',
  Square_20 = 'square-20',
  Square_40 = 'square-40',
}

interface AvatarPlaceholderConfig {
  size: string;
  borderRadius: string;
}

const AVATAR_CONFIG_MAP: Record<AvatarPlaceholderType, AvatarPlaceholderConfig> = {
  [AvatarPlaceholderType.Round_05]: { size: '24px', borderRadius: '50%' },
  [AvatarPlaceholderType.Round_0]: { size: '32px', borderRadius: '50%' },
  [AvatarPlaceholderType.Round_10]: { size: '48px', borderRadius: '50%' },
  [AvatarPlaceholderType.Square_0]: { size: '48px', borderRadius: '12px' },
  [AvatarPlaceholderType.Square_8]: { size: '40px', borderRadius: '8px' },
  [AvatarPlaceholderType.Square_20]: { size: '72px', borderRadius: '16px' },
  [AvatarPlaceholderType.Square_40]: { size: '160px', borderRadius: '32px' },
};

interface IAvatarPlaceholderProps {
  className?: string;
  type: AvatarPlaceholderType;
  isAnimated?: boolean;
  duration?: number;
}

export const AvatarPlaceholder: FC<IAvatarPlaceholderProps> = memo((props) => {
  const { type, isAnimated, className, duration = 500 } = props;
  const config = AVATAR_CONFIG_MAP[type];

  return (
    <Skeleton
      isAnimated={isAnimated}
      width={config.size}
      height={config.size}
      borderRadius={config.borderRadius}
      className={classNames(styles.container, className)}
      animationConfig={{
        duration,
        endPosition: config.size,
      }}
    />
  );
});
